import ReactDOM from 'react-dom';
import { IntlProvider } from 'Intl/Intl';
import { FormattedMessage, useIntl } from 'react-intl';

import { Icon, Tooltip } from 'dodoc-design-system';

import styles from './TableOfContentsElement.module.scss';

import { ReduxInterface } from 'Editor/services';
import StylesUtils from 'Editor/services/Styles/Utils/StylesUtils';
import { DISPLAY_TYPES, ELEMENTS } from 'Editor/services/consts';
import { BaseBlockElement } from '../..';
import DOMElementFactory from 'Editor/services/DOMUtilities/DOMElementFactory/DOMElementFactory';

const TableOfContentsElementContent = () => {
  const intl = useIntl();

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'CONTENT_CANNOT_BE_EDITED' })}
      testId="table-of-contents-cannot-be-edited-tooltip"
    >
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <Icon icon="PlaceholderTableOfContents" size={32} />
        </div>
        <div className={styles.info}>
          <FormattedMessage id={'EDITOR_DOCUMENT_TABLE_OF_CONTENTS'} />
        </div>
      </div>
    </Tooltip>
  );
};

export class TableOfContentsElementLegacy extends BaseBlockElement {
  private container?: HTMLElement;

  get selectableContent() {
    return this.container?.childNodes[0]?.childNodes[1] || null;
  }

  connectedCallback() {
    super.connectedCallback();
    this.buildElement();
  }

  get ALLOWED_STYLE_ATTRIBUTES() {
    return StylesUtils.ALLOWED_BLOCK_ATTRIBUTES_BY_ELEMENT[this.tag] || [];
  }

  get displayType() {
    return DISPLAY_TYPES.BLOCK;
  }

  get isEditable() {
    return false;
  }

  get isDeletable() {
    return !this.isLocked;
  }

  get isSplitable() {
    return false;
  }

  get isSelectable() {
    return true;
  }

  buildElement() {
    this.innerHTML = '';

    // this.setAttribute('contentEditable', false);
    this.setAttribute('spellcheck', 'false');

    this.container = DOMElementFactory.buildElement('div');
    this.container.setAttribute('class', styles.container);

    this.appendChild(this.container);

    const locale = ReduxInterface.getLocale();

    ReactDOM.unmountComponentAtNode(this.container);
    ReactDOM.render(
      <IntlProvider locale={locale}>
        <TableOfContentsElementContent />
      </IntlProvider>,
      this.container,
    );
  }
}

// register element
if (!window.customElements.get(ELEMENTS.TableOfContentsElement.IDENTIFIER_LEGACY)) {
  window.customElements.define(
    ELEMENTS.TableOfContentsElement.IDENTIFIER_LEGACY,
    TableOfContentsElementLegacy,
  );
}
